module.exports = __webpack_public_path__ + "static/media/3DPPA40.d92ad8fa.jpg";